import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PORTFOLIO_PROJECTS } from "../mock";
import Seo from "../components/Seo";

const Portfolio = () => {
  return (
    <div className="bg-[#0E0E0F] text-[#EDE3CB]">
      <Seo
        path="/portfolio"
        title="Selected Work"
        description="Selected case studies from Jesse J. Adams' property master career: All the Way (HBO/LBJ), Marvel's Agent Carter, Office Christmas Party, and Popstar: Never Stop Never Stopping. Period accuracy, fabrication, and on-set craft."
      />
      {/* Header */}
      <section className="max-w-[1440px] mx-auto px-6 lg:px-12 pt-20 pb-14">
        <div className="section-label">Portfolio</div>
        <h1 className="font-display text-6xl md:text-8xl mt-4 leading-[0.9]">Selected <span className="brass-text">work</span>.</h1>
        <p className="font-serif-accent italic text-xl md:text-2xl text-[#EDE3CB]/80 max-w-3xl mt-6 leading-snug">
          A closer look at a few projects — the research, the builds, the calls made on the fly, and the props that ended up on camera.
        </p>
      </section>

      <div className="brass-divider max-w-[1440px] mx-auto opacity-40" />

      {/* Project list */}
      <section className="max-w-[1440px] mx-auto px-6 lg:px-12 py-16 space-y-10 md:space-y-12">
        {PORTFOLIO_PROJECTS.map((p, i) => (
          <Link
            key={p.slug}
            to={`/portfolio/${p.slug}`}
            className="block group py-6 border-b border-white/5 last:border-b-0"
          >
            <div className={`grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-12 items-center ${i % 2 ? "lg:[direction:rtl]" : ""}`}>
              <div className="lg:col-span-4 [direction:ltr]">
                <div className="overflow-hidden bg-[#0B0B0C] border border-white/5 aspect-[2/3] max-w-[260px] sm:max-w-[300px] mx-auto lg:mx-0 shadow-[0_20px_50px_-20px_rgba(0,0,0,0.8)]">
                  <img src={p.poster || p.hero} alt={`${p.title} poster`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" />
                </div>
              </div>
              <div className="lg:col-span-8 [direction:ltr]">
                <div className="text-[10px] tracking-[0.32em] uppercase text-[#B8935A] mb-3">
                  {p.studio}
                </div>
                <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[0.95] group-hover:text-[#B8935A] transition-colors">
                  {p.title}
                </h2>
                <p className="font-serif-accent italic text-lg md:text-xl text-[#EDE3CB]/75 mt-3 leading-snug">
                  {p.subtitle}
                </p>
                <div className="brass-divider mt-6 max-w-[200px] opacity-60" />
                <div className="text-[12px] tracking-[0.22em] uppercase text-[#EDE3CB]/65 mt-5">
                  Directed by {p.director}
                </div>
                <div className="mt-6 inline-flex items-center gap-2 text-[#B8935A] text-xs tracking-[0.22em] uppercase font-medium link-underline">
                  Read the case study <ArrowUpRight size={14} />
                </div>
              </div>
            </div>
          </Link>
        ))}
      </section>

      {/* CTA */}
      <section className="max-w-[1440px] mx-auto px-6 lg:px-12 pb-24">
        <div className="border border-[#B8935A]/30 p-10 md:p-14 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div>
            <div className="section-label">Need something custom?</div>
            <h3 className="font-display text-3xl md:text-4xl mt-3 leading-tight">In-house fabrication, paper props, graphics, and 3D work.</h3>
          </div>
          <div className="flex flex-wrap gap-3 md:justify-end">
            <Link to="/contact" className="btn-primary">Check Availability <ArrowUpRight size={14} /></Link>
            <Link to="/services" className="btn-secondary">The Prop Department</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Portfolio;
